/**
 * Mock exam countdown duration per university (minutes).
 * Unlisted universities use DEFAULT_MOCK_COUNTDOWN_MINUTES.
 *
 * Matching is case-insensitive and ignores extra spaces, so values in Redux/DB
 * like "The University of Manchester" still resolve if you list the variants you use.
 */
export const DEFAULT_MOCK_COUNTDOWN_MINUTES = 90;

/** Human-readable keys (any casing); see resolveMinutesForUniversity */
export const MOCK_COUNTDOWN_MINUTES_BY_UNIVERSITY = {
  "University of Manchester": 60,
  "The University of Manchester": 60,
};

function normalizeUniversityLabel(name) {
  return String(name)
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();
}

/** Map normalized label -> minutes (built once from MOCK_COUNTDOWN_...) */
const MINUTES_BY_NORMALIZED = Object.fromEntries(
  Object.entries(MOCK_COUNTDOWN_MINUTES_BY_UNIVERSITY).map(([label, mins]) => [
    normalizeUniversityLabel(label),
    mins,
  ])
);

/**
 * @param {string | null | undefined} universityName — e.g. from Redux state.auth.universityName
 * @returns {number} duration in milliseconds
 */
export function getMockCountdownDurationMs(universityName) {
  if (!universityName || typeof universityName !== "string") {
    return DEFAULT_MOCK_COUNTDOWN_MINUTES * 60 * 1000;
  }
  const normalized = normalizeUniversityLabel(universityName);
  const minutes =
    MINUTES_BY_NORMALIZED[normalized] ?? DEFAULT_MOCK_COUNTDOWN_MINUTES;
  return minutes * 60 * 1000;
}
